(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/game-promotion-odds-prepack/assets/javascripts/fetch-prepack.js') >= 0) return;  svs.modules.push('/components/banner_layouts/game-promotion-odds-prepack/assets/javascripts/fetch-prepack.js');

'use strict';

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const normalize = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').normalize : svs.components.oddset.kambiOffering.common.normalize;
const kambiOffering = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').offering : svs.components.oddset.kambiOffering;
const logger = getLogger('banner_layouts:game-promotion-odds-prepack:fetch-prepack');
const getNormalizedPrepacksData = async prepackId => {
  try {
    const prepacksData = await kambiOffering.getPrepacks(prepackId);
    const normalizedResponse = normalize.normalizePrepack(prepacksData);
    return normalizedResponse;
  } catch (error) {
    logger.warn('Something went wrong while retrieving Kambis prepack data:', error);
    return null;
  }
};
if (svs.isServer) {
  module.exports = {
    getNormalizedPrepacksData
  };
} else {
  setGlobal('svs.banner_layouts.game_promotion_odds_prepack', {
    getNormalizedPrepacksData
  });
}

 })(window);